import { useState } from 'react';
import axios from 'axios';

// Prominent Package preset selector for Customer + Lead records.
// Choosing a package activates its modules by stamping a renewal date
// (today + 1 year) on each — add-only, never overwriting an existing
// date. Customers apply to every site; leads to their single row.
export const PACKAGES = ['Price Book Only', 'Standard', 'Full Suite'];

const PACKAGE_HINT = {
  'Price Book Only': 'Activates Price Book.',
  'Standard': 'Activates Price Book, Fuel Manager, Real Time Inventory, SFT File.',
  'Full Suite': 'Activates all modules.'
};

export default function PackageSelector({ contactId, recordType, value, siteCount = 0, onApplied }) {
  const [pkg, setPkg] = useState(value || '');
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState(null);
  const [error, setError] = useState(null);

  async function apply(next) {
    if (!next) return;
    if (recordType === 'customer' && siteCount > 0) {
      const ok = window.confirm(
        `Apply the "${next}" package to all ${siteCount} site${siteCount === 1 ? '' : 's'} ` +
        `under this customer? Each package module gets a renewal date one year out. ` +
        `Modules that already have a renewal date are left unchanged.`
      );
      if (!ok) return;
    }
    setBusy(true); setError(null); setMsg(null);
    try {
      const res = await axios.post('/api/subscriptions/apply-package', { contact_id: contactId, package: next });
      setPkg(next);
      const n = res.data.sites_updated;
      setMsg(recordType === 'customer'
        ? `${next} applied to ${n} site${n === 1 ? '' : 's'}.`
        : `${next} applied.`);
      if (onApplied) onApplied();
      setTimeout(() => setMsg(null), 3000);
    } catch (err) {
      setError(err.response?.data?.error || err.message);
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="package-selector">
      <span className="package-label">Package</span>
      <select
        className="package-select"
        value={pkg}
        disabled={busy}
        onChange={(e) => apply(e.target.value)}
      >
        <option value="">— Select package —</option>
        {PACKAGES.map((p) => <option key={p} value={p}>{p}</option>)}
      </select>
      {pkg && <span className="package-hint">{PACKAGE_HINT[pkg]}</span>}
      {busy && <span className="package-hint">Applying…</span>}
      {msg && <span className="package-msg">{msg}</span>}
      {error && <span className="package-error">{error}</span>}
    </div>
  );
}
